import { createGlobalStyle as o } from "styled-components";
import { normalize as r } from "./polished.esm.mjs";
const t = o`${r()}`;
export {
  t as Normalize
};
//# sourceMappingURL=normalize.mjs.map
